var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc-icon",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":_vm.activityInfo.mapStyle.fnModule.activityDesc.buttonImg,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }